export const presentationCategories = ['presentation', 'action', 'training'];